// Constantes des packs one-shot (STARTER / FOCUS / PREMIUM).
// Source unique partagée entre le webhook Zoho (création automatique du grant à
// l'achat) et le modal ADM (attribution manuelle, paiement différé).
//
// ⚠️ Le nombre de sessions est IDENTIQUE pour les 3 tiers (50). Le tier ne pilote
// que le PÉRIMÈTRE simulateurs (STARTER=1, FOCUS=3, PREMIUM=tous les simulateurs ;
// coachs inclus dans toutes les formules depuis le 14/10/2026), jamais
// le nombre de sessions. Cf. src/lib/session-quota.ts.

/**
 * Nombre de sessions offertes par pack one-shot, PAR DÉFAUT (quand la licence ne
 * précise pas `sessions_per_pack`). Le tier ne pilote QUE le périmètre simulateurs.
 */
export const SESSIONS_PER_ONESHOT_PACK = 50;

/**
 * Nombre de crédits (sessions) créditées par un pack one-shot, × quantité (à appliquer
 * par l'appelant). Lit la colonne configurable `licences.sessions_per_pack` ; retombe
 * sur le défaut `SESSIONS_PER_ONESHOT_PACK` (50) si non renseignée (NULL / 0 / absente).
 */
export function sessionsPerOneShotPack(sessionsPerPack?: number | null): number {
  return sessionsPerPack != null && sessionsPerPack > 0 ? sessionsPerPack : SESSIONS_PER_ONESHOT_PACK;
}

/** Durée de validité d'un pack one-shot, en mois. */
export const ONESHOT_VALIDITY_MONTHS = 12;
